export default __webpack_public_path__ + "assignAssessment.html";